import { useGetApprovalTeamsQuery } from 'features/comments/approvalApi';

/** @var {import('models/approval.models').ApprovalTeam[]} */
const emptyArray = [];

/**
 * @returns {import('models/approval.models').ApprovalTeam[]}
 */
export function useGetApprovalTeams() {
    const { teams } = useGetApprovalTeamsQuery(undefined, {
        selectFromResult: ({ data }) => ({
            teams: data ?? emptyArray,
        }),
    });

    return teams;
}
